import { useClassified } from "@/contexts/classified";
import { useEffect, useState } from "react";
import { useBrowserAPI } from "@/hooks/useBrowserAPI";
export const useTags = () => {
    var _a, _b;
    const [isSeen, setIsSeen] = useState(false);
    const [isContacted, setIsContacted] = useState(false);
    const [isNew, setIsNew] = useState(false);
    const tags = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.tags;
    const classifiedId = (_b = useClassified()) === null || _b === void 0 ? void 0 : _b.id;
    const { bLocalStorage } = useBrowserAPI();
    useEffect(() => {
        var _a, _b, _c, _d, _e;
        setIsContacted(
        // @ts-ignore
        (_a = bLocalStorage.getItem("aviv_cdp_contact")) === null || _a === void 0 ? void 0 : _a.includes(classifiedId));
        setIsSeen(
        // @ts-ignore
        !((_b = bLocalStorage.getItem("aviv_cdp_contact")) === null || _b === void 0 ? void 0 : _b.includes(classifiedId)) &&
            (
            // @ts-ignore
            (_c = bLocalStorage.getItem("aviv_cdp_seen")) === null || _c === void 0 ? void 0 : _c.includes(classifiedId)));
        setIsNew(
        // @ts-ignore
        !((_d = bLocalStorage.getItem("aviv_cdp_contact")) === null || _d === void 0 ? void 0 : _d.includes(classifiedId)) &&
            // @ts-ignore
            !((_e = bLocalStorage.getItem("aviv_cdp_seen")) === null || _e === void 0 ? void 0 : _e.includes(classifiedId)) &&
            !!(tags === null || tags === void 0 ? void 0 : tags.isNew));
    }, [classifiedId, isContacted, tags === null || tags === void 0 ? void 0 : tags.isNew, bLocalStorage]);
    return {
        isExclusive: !!(tags === null || tags === void 0 ? void 0 : tags.isExclusive),
        hasBrokerageFee: tags === null || tags === void 0 ? void 0 : tags.hasBrokerageFee,
        isNew,
        isSeen,
        isContacted,
        isHdExclusive: !!(tags === null || tags === void 0 ? void 0 : tags.isHdExclusive),
    };
};
